import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getVersenytarsElemzes, createVersenytarsElemzes, updateVersenytarsElemzes, getSzak } from "../../apis/SzakokFinder";
import SideTile from "../SideTile";
import Modal from 'react-modal';
// import "../../components/Ujszak.css"; 
// import "./VersenytarsElemzes.css";
import "./SzakjelentesCreate.css";
import "./RadioButton.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext"; 
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { VERSENYTARSELEMZES_TRANSLATIONS } from './VersenytarsElemzesTranslations';
import {
    JELENTKEZOK_SZAMA_OPTIONS,
    VERSENYKEPESSEG_OPTIONS,
    NEMZETKOZI_LEHETOSEGEK_OPTIONS,
    JELENLEGI_PARTNEREK_OPTIONS,
    ANGOL_NYELVU_STATUSZ_OPTIONS
} from './VersenytarsElemzesOptions'; 



const VersenytarsElemzesContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();


    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);  // Reference for the SideTile container

    const [versenytarsElemzes, setVersenytarsElemzes] = useState({
        hazai_intezmenyek: "",
        nemzetkozi_versenytarsak: "",
        filling_status: 1
    });

    // Radio button state for section 10.1
    const [jelentkezokSzamaValasztas, setJelentkezokSzamaValasztas] = useState("");
    const [versenykepessegValasztas, setVersenykepessegValasztas] = useState("");

    // Checkbox state for section 10.2
    const [nemzetkoziLehetosegekValasztas, setNemzetkoziLehetosegekValasztas] = useState([]);
    const [jelenlegiPartnerekValasztas, setJelenlegiPartnerekValasztas] = useState([]);
    const [jelenlegiPartnerekEgyeb, setJelenlegiPartnerekEgyeb] = useState("");

    // Radio button state for section 10.3
    const [angolNyelvuStatuszValasztas, setAngolNyelvuStatuszValasztas] = useState("");

    const [images, setImages] = useState({});

    const [isNew, setIsNew] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);
    const [saveTimeout, setSaveTimeout] = useState(null);
    const [szakStatus, setSzakStatus] = useState(1);
    
    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Get translations and options for current language
    const t = loading ? {} : (VERSENYTARSELEMZES_TRANSLATIONS[language] || VERSENYTARSELEMZES_TRANSLATIONS.hu);
    const jelentkezokSzamaOptions = loading ? [] : (JELENTKEZOK_SZAMA_OPTIONS[language] || JELENTKEZOK_SZAMA_OPTIONS.hu);
    const versenykepessegOptions = loading ? [] : (VERSENYKEPESSEG_OPTIONS[language] || VERSENYKEPESSEG_OPTIONS.hu);
    const nemzetkoziLehetosegekOptions = loading ? [] : (NEMZETKOZI_LEHETOSEGEK_OPTIONS[language] || NEMZETKOZI_LEHETOSEGEK_OPTIONS.hu);
    const jelenlegiPartnerekOptions = loading ? [] : (JELENLEGI_PARTNEREK_OPTIONS[language] || JELENLEGI_PARTNEREK_OPTIONS.hu);
    const angolNyelvuStatuszOptions = loading ? [] : (ANGOL_NYELVU_STATUSZ_OPTIONS[language] || ANGOL_NYELVU_STATUSZ_OPTIONS.hu);
    const isHungarian = language === 'hu';

    const sections = {
        magyar: "magyar_section",
        nemzetkozi: "nemzetkozi_section"
    };

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const versenytarsElemzesResponse = await getVersenytarsElemzes(szakId);
                if (versenytarsElemzesResponse.data.data.versenytarsElemzes) {
                    const data = versenytarsElemzesResponse.data.data.versenytarsElemzes;
                    setVersenytarsElemzes(data);
                    
                    // Load radio button selections from JSONB
                    if (data.jelentkezok_szama_valasztas) setJelentkezokSzamaValasztas(data.jelentkezok_szama_valasztas.selected || "");
                    if (data.versenykepesseg_valasztas) setVersenykepessegValasztas(data.versenykepesseg_valasztas.selected || "");
                    
                    // Load checkbox selections from JSONB
                    if (data.nemzetkozi_lehetosegek_valasztas) setNemzetkoziLehetosegekValasztas(data.nemzetkozi_lehetosegek_valasztas.selected || []);
                    if (data.jelenlegi_partnerek_valasztas) setJelenlegiPartnerekValasztas(data.jelenlegi_partnerek_valasztas.selected || []);
                    if (data.jelenlegi_partnerek_egyeb) setJelenlegiPartnerekEgyeb(data.jelenlegi_partnerek_egyeb);
                    
                    // Load section 10.3 radio button
                    if (data.angol_nyelvu_statusz_valasztas) setAngolNyelvuStatuszValasztas(data.angol_nyelvu_statusz_valasztas.selected || "");
                    
                    await fetchImages();
                    setIsNew(false);
                } else {
                    // Automatically set filling_status to 1 and save it if there's no data yet
                    await createVersenytarsElemzes(szakId, { ...versenytarsElemzes, filling_status: 1 });
                    window.location.reload();  // Reload page after record creation
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // Ha 404-es hiba lép fel, új bejegyzés létrehozása filling_status: 1-gyel
                    const newRecord = { ...versenytarsElemzes, filling_status: 1 };
                    try {
                        await createVersenytarsElemzes(szakId, newRecord);
                        window.location.reload();  // Frissítjük az oldalt a sikeres létrehozás után
                    } catch (createError) {
                        console.error("Error creating new record:", createError);
                    }
                } else {
                    console.log("Error fetching data:", error);
                }
            }
        };
        fetchData();
    }, [szakId]);

    const fetchImages = async () => {
        try {
            const magyarImages = await fetchImagesBySection(sections.magyar);
            const nemzetkoziImages = await fetchImagesBySection(sections.nemzetkozi);

            setImages({
                magyar_section: magyarImages,
                nemzetkozi_section: nemzetkoziImages,
            });
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    const fetchImagesBySection = async (section) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakok/${szakId}/images/${section}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Error fetching images for section ${section}`);
            }

            const data = await response.json();
            return data.data || [];
        } catch (error) {
            console.error(`Error fetching images for section ${section}:`, error);
            return [];
        }
    };

    const handleChange = (field, value) => {
        setVersenytarsElemzes(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
    };


    const handleDrop = async (acceptedFiles, section) => {
        const formData = new FormData();
        formData.append('image', acceptedFiles[0]);
        formData.append('section', section);
    
        try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL; // Környezeti változó használata
            // Token nélküli feltöltési kérés
            const response = await fetch(`${baseUrl}/upload/${szakId}`, {
                method: 'POST',
                body: formData,
            });
    
            if (!response.ok) {
                throw new Error('Failed to upload image');
            }
    
            const uploadResponse = await response.json();
    
            if (uploadResponse && uploadResponse.image_path) {
                const imagePath = uploadResponse.image_path.replace('uploads/', '');
                setImages((prevImages) => ({
                    ...prevImages,
                    [section]: [...prevImages[section], { ...uploadResponse, image_path: imagePath }]
                }));
            } else {
                console.error('Unexpected response format:', uploadResponse);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };
    

    const handleDeleteImage = async (imageId, section) => {
        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakjelentes_letrehozas/${szakId}/images/${imageId}`, {
                method: 'DELETE',
            });

            setImages((prevImages) => ({
                ...prevImages,
                [section]: prevImages[section].filter(img => img.id !== imageId)
            }));
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { ...versenytarsElemzes, filling_status: 2 }; // Always save with status 2
            try {
                if (isNew) {
                    await createVersenytarsElemzes(szakId, updatedData);
                } else {
                    await updateVersenytarsElemzes(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [versenytarsElemzes, isNew, szakId, registerSaveHandler, unregisterSaveHandler]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = { 
            ...versenytarsElemzes, 
            filling_status: status,
            jelentkezok_szama_valasztas: buildRadioData(jelentkezokSzamaValasztas, jelentkezokSzamaOptions),
            versenykepesseg_valasztas: buildRadioData(versenykepessegValasztas, versenykepessegOptions),
            nemzetkozi_lehetosegek_valasztas: buildMultiSelectData(nemzetkoziLehetosegekValasztas, nemzetkoziLehetosegekOptions),
            jelenlegi_partnerek_valasztas: buildMultiSelectData(jelenlegiPartnerekValasztas, jelenlegiPartnerekOptions),
            jelenlegi_partnerek_egyeb: jelenlegiPartnerekValasztas.includes('egyeb') ? jelenlegiPartnerekEgyeb : '',
            angol_nyelvu_statusz_valasztas: buildRadioData(angolNyelvuStatuszValasztas, angolNyelvuStatuszOptions)
        };

        try {
            if (isNew) {
                await createVersenytarsElemzes(szakId, updatedData);
            } else {
                await updateVersenytarsElemzes(szakId, updatedData);
            }

            window.location.reload();  // Reload the page after save or finalize
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/meghivott-eloadok`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/szak-letszam-adatok`);
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        // Check if "egyeb" is selected and has text
        const egyebValid = !jelenlegiPartnerekValasztas.includes('egyeb') || hasContent(jelenlegiPartnerekEgyeb);

        return (
            hasContent(versenytarsElemzes.hazai_intezmenyek) &&
            jelentkezokSzamaValasztas !== "" &&
            versenykepessegValasztas !== "" &&
            nemzetkoziLehetosegekValasztas.length > 0 &&
            jelenlegiPartnerekValasztas.length > 0 &&
            egyebValid &&
            hasContent(versenytarsElemzes.nemzetkozi_versenytarsak) &&
            (!isHungarian || angolNyelvuStatuszValasztas !== "")
        );
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3); // Véglegesítés
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts?.requiredFields || "Minden szöveges mezőt ki kell tölteni!");
            setShowAlert(true);
        }
    };

    const handleRevertFinalize = async (e) => {
        e.preventDefault();
        const updatedData = { ...versenytarsElemzes, filling_status: 2 };

        try {
            await updateVersenytarsElemzes(szakId, updatedData);
            window.location.reload();  // Reload the page after reverting finalize
        } catch (error) {
            console.error("Error reverting finalize:", error);
            alert("Error reverting finalize.");
        }
    };

    const { getRootProps: getRootPropsMagyar, getInputProps: getInputPropsMagyar, isDragActive: isDragActiveMagyar } = useDropzone({
        onDrop: (files) => handleDrop(files, sections.magyar),
        accept: 'image/*',
        disabled: versenytarsElemzes.filling_status === 3  // Disable dropzone if finalized
    });

    const { getRootProps: getRootPropsNemzetkozi, getInputProps: getInputPropsNemzetkozi, isDragActive: isDragActiveNemzetkozi } = useDropzone({
        onDrop: (files) => handleDrop(files, sections.nemzetkozi),
        accept: 'image/*',
        disabled: versenytarsElemzes.filling_status === 3  // Disable dropzone if finalized
    });

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">
                        <h2>{t.section101.title}</h2>
                        <p>
                            {t.section101.description1} <br></br>
                            {t.section101.description2} 
                          <p>{t.section101.source}<a href="https://munkatars.sze.hu/orszagos-felveteli-adatok" target="_blank" rel="noopener noreferrer">https://munkatars.sze.hu/orszagos-felveteli-adatok</a></p>  
                        </p>
                        <p>{t.section101.subtitle}</p>
                        <div className="form-group">
                            <RichTextEditor
                                name="hazai_intezmenyek"
                                value={versenytarsElemzes.hazai_intezmenyek}
                                onChange={(value) => handleChange("hazai_intezmenyek", value)}
                                disabled={versenytarsElemzes.filling_status === 3}
                                section="hazai_intezmenyek"
                            />
                        </div>
                        <h4>{t.section101.subtitle1}</h4>  
                        <div className="form-group">
                            {jelentkezokSzamaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`jelentkezok_szama_${option.value}`}
                                        name="jelentkezok_szama"
                                        value={option.value}
                                        checked={jelentkezokSzamaValasztas === option.value}
                                        onChange={(e) => setJelentkezokSzamaValasztas(e.target.value)}
                                        disabled={versenytarsElemzes.filling_status === 3}
                                    />
                                    <label htmlFor={`jelentkezok_szama_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section101.subtitle2}</h4>
                        <div className="form-group">
                            {versenykepessegOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`versenykepesseg_${option.value}`}
                                        name="versenykepesseg"
                                        value={option.value}
                                        checked={versenykepessegValasztas === option.value}
                                        onChange={(e) => setVersenykepessegValasztas(e.target.value)}
                                        disabled={versenytarsElemzes.filling_status === 3}
                                    />
                                    <label htmlFor={`versenykepesseg_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section102.title}</h2>
                        
                        <h5>{t.section102.subtitle1}</h5>
                        <div className="form-group">
                            <RichTextEditor
                                name="nemzetkozi_versenytarsak"
                                value={versenytarsElemzes.nemzetkozi_versenytarsak}
                                onChange={(value) =>
                                    handleChange("nemzetkozi_versenytarsak", value)
                                  }
                                disabled={versenytarsElemzes.filling_status === 3}
                                section="nemzetkozi_versenytarsak"
                            />
                        </div>
                        
                        <h4>{t.section102.subtitle2}</h4>
                        <div className="form-group">
                            {nemzetkoziLehetosegekOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`nemzetkozi_lehetosegek_${option.value}`}
                                        value={option.value}
                                        checked={nemzetkoziLehetosegekValasztas.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setNemzetkoziLehetosegekValasztas([...nemzetkoziLehetosegekValasztas, option.value]);
                                            } else {
                                                setNemzetkoziLehetosegekValasztas(nemzetkoziLehetosegekValasztas.filter(val => val !== option.value));
                                            }
                                        }}
                                        disabled={versenytarsElemzes.filling_status === 3}
                                    />
                                    <label htmlFor={`nemzetkozi_lehetosegek_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section102.subtitle3}</h4>
                        <div className="form-group">
                            {jelenlegiPartnerekOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`jelenlegi_partnerek_${option.value}`}
                                        value={option.value}
                                        checked={jelenlegiPartnerekValasztas.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setJelenlegiPartnerekValasztas([...jelenlegiPartnerekValasztas, option.value]);
                                            } else {
                                                setJelenlegiPartnerekValasztas(jelenlegiPartnerekValasztas.filter(val => val !== option.value));
                                            }
                                        }}
                                        disabled={versenytarsElemzes.filling_status === 3}
                                    />
                                    <label htmlFor={`jelenlegi_partnerek_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {jelenlegiPartnerekValasztas.includes('egyeb') && (
                            <div className="form-group">
                                <RichTextEditor
                                    name="jelenlegi_partnerek_egyeb"
                                    value={jelenlegiPartnerekEgyeb}
                                    onChange={(value) => setJelenlegiPartnerekEgyeb(value)}
                                    disabled={versenytarsElemzes.filling_status === 3}
                                    section="jelenlegi_partnerek_egyeb"
                                />
                            </div>
                        )}

                    </div>

                    {isHungarian && (
                        <div className="card">
                            <h2>{t.section103.title}</h2>
                            <p>{t.section103.subtitle}</p>
                            <div className="form-group">
                                {angolNyelvuStatuszOptions.map((option) => (
                                    <div className="radio-group" key={option.value}>
                                        <input
                                            type="radio"
                                            id={`angol_nyelvu_statusz_${option.value}`}
                                            name="angol_nyelvu_statusz"
                                            value={option.value}
                                            checked={angolNyelvuStatuszValasztas === option.value}
                                            onChange={(e) => setAngolNyelvuStatuszValasztas(e.target.value)}
                                            disabled={versenytarsElemzes.filling_status === 3}
                                        />
                                        <label htmlFor={`angol_nyelvu_statusz_${option.value}`}>{option.label}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="button-container-left">
                        <button className="szak-button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={versenytarsElemzes.filling_status === 3 || szakStatus >= 2}>{t.buttons.save}</button>
                        {versenytarsElemzes.filling_status === 3 ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleRevertFinalize} disabled={szakStatus >= 2}>{t.buttons.unfinalize}</button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>{t.buttons.finalize}</button>
                        )}
                    </div>
                </form>
            </div>

            <SideTile 
                ref={sideTileRef}
                id={szakId} 
                texts={t.sidebar}
                isVisible={isSideTileVisible}
            />

            <Modal
                isOpen={!!selectedImage} 
                onRequestClose={() => setSelectedImage(null)} 
                contentLabel={t.modal?.imageAlt || "Kép nagyítása"}
                className="image-modal"
                overlayClassName="image-modal-overlay"
            >
                {selectedImage && (
                    <div>
                        <img src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${selectedImage}`} alt={t.modal?.imageAlt || "Nagyított kép"} className="modal-image"/>
                        <button onClick={() => setSelectedImage(null)} className="modal-close-button">
                            <i className="material-icons">close</i>
                        </button>
                    </div>
                )}
            </Modal>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const VersenytarsElemzes = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <VersenytarsElemzesContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default VersenytarsElemzes;
